module.exports = "/images/18K.webp?b450b719374999afbe0fef72a4c23c16";